(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".media-banner__heading");

    if (!text) return;

    window.themeRevealOnScroll(
      text,
      () => text.classList.add("animated"),
      "0px 0px -5% 0px"
    );
  };

  initAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
  });
})();
